"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEpgTitleProperty = exports.epgTitlePropertyDefinition = void 0;
exports.epgTitlePropertyDefinition = {
    view: {
        label: 'EPG Title',
        placeholder: 'Add EPG title',
        hint: 'This title is optional and will be used for EPGs on Partner platforms. If no EPG title is set, we would fall back to the regular title.',
    },
    constraints: [
        {
            name: 'maxLength',
            argument: 55,
        },
    ],
    type: 'text',
    multiple: false,
    name: 'epg-title',
};
const isEpgTitleProperty = (prop) => {
    return prop.name === exports.epgTitlePropertyDefinition.name;
};
exports.isEpgTitleProperty = isEpgTitleProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXBnLXRpdGxlLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvZXBnLXRpdGxlLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsMEJBQTBCLEdBQUc7SUFDeEMsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLFdBQVc7UUFDbEIsV0FBVyxFQUFFLGVBQWU7UUFDNUIsSUFBSSxFQUFFLHlJQUF5STtLQUNoSjtJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFdBQVc7WUFDakIsUUFBUSxFQUFFLEVBQUU7U0FDYjtLQUNGO0lBQ0QsSUFBSSxFQUFFLE1BQU07SUFDWixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxXQUFXO0NBQ2MsQ0FBQTtBQUkxQixNQUFNLGtCQUFrQixHQUFHLENBQUMsSUFBa0IsRUFBNEIsRUFBRTtJQUNqRixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssa0NBQTBCLENBQUMsSUFBSSxDQUFBO0FBQ3RELENBQUMsQ0FBQTtBQUZZLFFBQUEsa0JBQWtCLHNCQUU5QiJ9